document.addEventListener('DOMContentLoaded', function () {

  const builder = document.querySelector('#product-builder');

  if (!builder) return;


  /* =====================================================
     MOBILE + TABLET BREAKPOINT
     Match CSS exactly: max-width 999px
     ===================================================== */

  const mobileTabletQuery =
    window.matchMedia('(max-width: 999px)');


  /* =====================================================
     READ PRODUCT THUMBNAIL LAYOUT
     ===================================================== */

  const rawThumbnailLayout =
    Number(window.cpbThumbnailLayout) || 1;


  const thumbnailLayout =
    [1, 2, 3].includes(rawThumbnailLayout)
      ? rawThumbnailLayout
      : 1;


  builder.classList.remove(
    'cpb-thumb-layout-1',
    'cpb-thumb-layout-2',
    'cpb-thumb-layout-3'
  );


  builder.classList.add(
    `cpb-thumb-layout-${thumbnailLayout}`
  );


  /* =====================================================
     SHARED ELEMENT LOOKUP
     ===================================================== */

  function getThumbElements() {

    const thumbs =
      builder.querySelector('.cpb-swiper-thumbnails');

    const container =
      thumbs?.querySelector('.swiper-container');

    const wrapper =
      thumbs?.querySelector('.swiper-wrapper');

    if (!thumbs || !container || !wrapper) {
      return null;
    }

    return {
      thumbs,
      container,
      wrapper
    };

  }


  /* =====================================================
     SHARED HELPERS
     ===================================================== */

  function getSlides(wrapper) {

    return Array.from(
      wrapper.querySelectorAll('.swiper-slide')
    );

  }


  function getActiveSlide(wrapper) {

    return (
      wrapper.querySelector('.swiper-slide-thumb-active') ||
      wrapper.querySelector('.swiper-slide-active')
    );

  }


  function clearMobileState(
    thumbs,
    wrapper
  ) {

    wrapper.style.removeProperty(
      '--mobile-thumb-x'
    );

    wrapper.style.removeProperty(
      '--mobile-thumb-y'
    );

    wrapper.style.removeProperty(
      'transition'
    );


    thumbs.classList.remove(
      'cpb-thumbs-scrolled',
      'cpb-thumbs-at-end',
      'cpb-thumbs-no-fade'
    );

  }


  /* =====================================================
     LAYOUT 1
     ORIGINAL STRIP BELOW PREVIEW

     No custom movement JS needed.
     CSS restores the original horizontal strip.
     ===================================================== */

  function setupOriginalThumbStrip() {

    const elements =
      getThumbElements();

    if (!elements) return;


    const {
      thumbs,
      wrapper
    } = elements;


    clearMobileState(
      thumbs,
      wrapper
    );

  }


  /* =====================================================
     LAYOUT 2
     VERTICAL LEFT
     ===================================================== */

  function setupVerticalThumbScroller() {

    if (!mobileTabletQuery.matches) return;


    const elements =
      getThumbElements();

    if (!elements) return;


    const {
      thumbs,
      container,
      wrapper
    } = elements;


    let currentY = 0;
    let previousActiveIndex = 0;


    function setThumbPosition(
      y,
      animate = true
    ) {

      currentY = y;


      wrapper.style.setProperty(
        '--mobile-thumb-y',
        `${currentY}px`
      );


      const maxScroll =
        Math.max(
          0,
          wrapper.scrollHeight -
          container.clientHeight
        );


      const needsFade =
        wrapper.scrollHeight >
        container.clientHeight;


      const hasHiddenAbove =
        needsFade &&
        currentY < -2;


      const hasHiddenBelow =
        needsFade &&
        currentY >
          (-maxScroll + 2);


      thumbs.classList.toggle(
        'cpb-thumbs-scrolled',
        hasHiddenAbove
      );


      thumbs.classList.toggle(
        'cpb-thumbs-at-end',
        needsFade &&
        !hasHiddenBelow
      );


      thumbs.classList.toggle(
        'cpb-thumbs-no-fade',
        !needsFade
      );


      wrapper.style.setProperty(
        'transition',
        animate
          ? 'transform 250ms ease'
          : 'none',
        'important'
      );

    }


    function keepActiveThumbVisible() {

      const active =
        getActiveSlide(wrapper);

      if (!active) return;


      const slides =
        getSlides(wrapper);


      const activeIndex =
        slides.indexOf(active);

      if (activeIndex === -1) return;


      const movingBackward =
        activeIndex <
        previousActiveIndex;


      const movingForward =
        activeIndex >
        previousActiveIndex;


      const containerHeight =
        container.clientHeight;


      const activeTop =
        active.offsetTop;


      const activeHeight =
        active.offsetHeight;


      const computed =
        getComputedStyle(builder);


      const thumbGap =
        parseFloat(
          computed.getPropertyValue(
            '--mobile-thumb-gap'
          )
        ) || 10;


      const fadeBottom =
        parseFloat(
          computed.getPropertyValue(
            '--mobile-fade-bottom'
          )
        ) || 28;


      const visibleBottom =
        containerHeight -
        fadeBottom;


      const activeVisibleTop =
        activeTop +
        currentY;


      const activeVisibleBottom =
        activeVisibleTop +
        activeHeight;


      let targetY =
        currentY;


      if (
        movingForward &&
        activeVisibleBottom >
          visibleBottom
      ) {

        targetY -=
          activeVisibleBottom -
          visibleBottom +
          thumbGap;

      }


      if (movingBackward) {

        targetY =
          visibleBottom -
          activeTop -
          activeHeight;

      }


      if (
        !movingBackward &&
        activeVisibleTop < 0
      ) {

        targetY +=
          -activeVisibleTop +
          thumbGap;

      }


      targetY =
        Math.min(
          0,
          targetY
        );


      const maxScroll =
        Math.max(
          0,
          wrapper.scrollHeight -
          containerHeight
        );


      targetY =
        Math.max(
          -maxScroll,
          targetY
        );


      setThumbPosition(
        targetY,
        true
      );


      previousActiveIndex =
        activeIndex;

    }


    const observer =
      new MutationObserver(function (mutations) {

        let activeChanged =
          false;


        mutations.forEach(function (mutation) {

          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {

            activeChanged =
              true;

          }

        });


        if (activeChanged) {

          requestAnimationFrame(
            keepActiveThumbVisible
          );

        }

      });


    getSlides(wrapper).forEach(function (slide) {

      observer.observe(
        slide,
        {
          attributes: true,
          attributeFilter: ['class']
        }
      );

    });


    const initialActive =
      getActiveSlide(wrapper);


    if (initialActive) {

      const initialIndex =
        getSlides(wrapper).indexOf(
          initialActive
        );


      if (initialIndex >= 0) {

        previousActiveIndex =
          initialIndex;

      }

    }


    setThumbPosition(
      0,
      false
    );


    requestAnimationFrame(function () {

      keepActiveThumbVisible();


      requestAnimationFrame(function () {

        wrapper.style.setProperty(
          'transition',
          'transform 250ms ease',
          'important'
        );

      });

    });

  }


  /* =====================================================
     LAYOUT 3
     HORIZONTAL CENTERED
     ===================================================== */

  function setupHorizontalCenteredThumbs() {

    if (!mobileTabletQuery.matches) return;


    const elements =
      getThumbElements();

    if (!elements) return;


    const {
      thumbs,
      container,
      wrapper
    } = elements;


    function centerActiveThumb(
      animate = true
    ) {

      const active =
        getActiveSlide(wrapper);

      if (!active) return;


      const containerWidth =
        container.clientWidth;


      const activeCenter =
        active.offsetLeft +
        (active.offsetWidth / 2);


      const targetCenter =
        containerWidth / 2;


      const targetX =
        targetCenter -
        activeCenter;


      wrapper.style.setProperty(
        '--mobile-thumb-x',
        `${targetX}px`
      );


      wrapper.style.setProperty(
        'transition',
        animate
          ? 'transform 250ms ease'
          : 'none',
        'important'
      );


      const needsFade =
        wrapper.scrollWidth >
        containerWidth;


      thumbs.classList.toggle(
        'cpb-thumbs-no-fade',
        !needsFade
      );

    }


    const observer =
      new MutationObserver(function (mutations) {

        let activeChanged =
          false;


        mutations.forEach(function (mutation) {

          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {

            activeChanged =
              true;

          }

        });


        if (activeChanged) {

          requestAnimationFrame(function () {

            centerActiveThumb(true);

          });

        }

      });


    getSlides(wrapper).forEach(function (slide) {

      observer.observe(
        slide,
        {
          attributes: true,
          attributeFilter: ['class']
        }
      );

    });


    requestAnimationFrame(function () {

      centerActiveThumb(false);


      requestAnimationFrame(function () {

        wrapper.style.setProperty(
          'transition',
          'transform 250ms ease',
          'important'
        );

      });

    });

  }


  /* =====================================================
     INITIALISE CORRECT LAYOUT
     ===================================================== */

  function initialiseThumbnailLayout() {

    if (!mobileTabletQuery.matches) {
      return;
    }


    if (thumbnailLayout === 3) {

      setupHorizontalCenteredThumbs();
      return;

    }


    if (thumbnailLayout === 2) {

      setupVerticalThumbScroller();
      return;

    }


    setupOriginalThumbStrip();

  }


  /* =====================================================
     WAIT FOR CPB TO CREATE THUMBNAIL SWIPER
     ===================================================== */

  let attempts = 0;


  const initTimer =
    setInterval(function () {

      attempts++;


      const wrapper =
        builder.querySelector(
          '.cpb-swiper-thumbnails .swiper-wrapper'
        );


      if (wrapper) {

        clearInterval(
          initTimer
        );


        initialiseThumbnailLayout();

      }


      if (attempts > 40) {

        clearInterval(
          initTimer
        );

      }

    }, 250);


  /* =====================================================
     BREAKPOINT / RESIZE CLEANUP
     ===================================================== */

  function handleBreakpointChange() {

    const elements =
      getThumbElements();

    if (!elements) return;


    const {
      thumbs,
      wrapper
    } = elements;


    if (!mobileTabletQuery.matches) {

      clearMobileState(
        thumbs,
        wrapper
      );

      return;
    }


    /*
      If browser crosses from desktop back into
      mobile/tablet, restore the selected layout.
    */

    initialiseThumbnailLayout();

  }


  if (
    typeof mobileTabletQuery.addEventListener === 'function'
  ) {

    mobileTabletQuery.addEventListener(
      'change',
      handleBreakpointChange
    );

  } else {

    /*
      Older Safari fallback
    */

    mobileTabletQuery.addListener(
      handleBreakpointChange
    );

  }

});